(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name payments.controller:InternationalPaymentCtrl
     *
     * @description
     *
     */
    angular
        .module('payments')
        /*.controller('InternationalPaymentCroCtrl', InternationalPaymentCroCtrl);*/
        .controller('InternationalPaymentMneCtrl', InternationalPaymentMneCtrl);

    function InternationalPaymentMneCtrl($rootScope, $location, CTLocalizationService, UserSettingsService, $state, $log, PurposeCodesService, $localStorage, 
        BicBanksService, CountriesService, PaymentTypesService, PaymentsService, HelperService, $q, $timeout, PaymentTemplatesService, ValidationService,
        CreditAccountRegisterService, AlertService, GoogleTagManagerHelperService, NotificationService, AccountsService) {
        var vm = this;

        vm.paymentResponse = {};

        vm.purposeCodesFilter = {
            page: 0,
            pageSize: 1000
        };

        vm.countriesFilter = {
            page: 0,
            pageSize: 1000
        };

        vm.payeeFilter = {
            paymentTypeGroup: 'ForeignPayment',
            orderBy: 'receiverName ASC',
            page: 0,
            pageSize: 1000
        };

        vm.templateName = '';
        vm.templatesFilter = {
            paymentTypeGroup: 'ForeignPayment',
            page: 0,
            pageSize: 1000
        };
        vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
        vm.uiMaskOptions = ValidationService.getUiMaskOptions().international.iban;
        vm.guideURL = '';
        vm.countryCode = $localStorage.code;
        vm.totalAmountWithFee = '';
        vm.tempForpObj = {
            payersNameInput: '',
            payersAddressInput: '',
            payersCityInput: '',
            fromAccountSelect: {},
            amountInput: '',
            dueDateInput: new Date(),
            paymentPurposeInput: '',
            paymentPurposeReceiverInfoInput: '',
            paymentMode: '',
            purposeCodeSelect: null,
            recipientStatusRadiobutton: {
                type: '2'
            },
            fullNameCompanyInput: '',
            recipientAddressInput: '',
            recipientCityInput: '',
            recipientCountrySelect: {},
            recipientAccountInput: '',
            bankNameInput: '',
            bankAddressInput: '',
            bankCityInput: '',
            bankCountrySelect: {},
            benBankCountrySelect: {},
            swiftCodeInput: '',
            bankChargesRadiobutton: {
                type: '' 
            },
            formSubmitted: false,
            receiversSepaInput1: '',
            receiversSepaInput2: '',
            payersSepaInput1: '',
            payersSepaInput2: '',
            email: '',
            phone: '',
            recieverType: '', // Primatelj (osoba)
            spentOption: '' // Tro�kovna opcija
        };
        

        vm.forUpdate = false;
        vm.ibanInvalid = false;
        vm.bicPopulated = false;
        vm.dataLoaded = false;
        vm.datePickerOpened = false;
        vm.disableBicData = false;
        vm.loadingInProgress = false;

        vm.goBack = function () {
            $state.go('payments.paymentsOverview');
        };

        vm.dateOptions = {
            minDate: new Date(),
            maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };

        vm.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        vm.steps = {
            step1: true,
            step2: false,
            step3: false,
            step4: false
        };


        vm.goBack = function () {
            $state.go('payments');
        };

        vm.onAccountFrom = function(account) {
            vm.tempForpObj.fromAccountSelect = account; 
            vm.showAccountToDropdown = !vm.showAccountToDropdown;
            vm.showAccountToDropdown = false;
            vm.checkIfSEPAPossible();
        }

        vm.getUserSettingsPage = function () {

            UserSettingsService.getPage(vm.userSettingsFilter)
                .then(function (response) {
                    var userSettings = response.result[0];
                    vm.tempForpObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
                    vm.tempForpObj.payersAddressInput = userSettings.address1;
                    vm.tempForpObj.payersCityInput = userSettings.city;


                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        vm.loadPurposeCode = function () {
            return PurposeCodesService.getPaymentBasis(vm.purposeCodesFilter)
                .then(function (response) {
                    _.forEach(response.result, function (value) {
                        value.optionValue = value.purposeCode + ' - ' + value.purposeDesc;
                    });
                    vm.purposeCodes = response.result;
                })
                .catch(function (error) {

                });
        };

        vm.loadCountries = function () {
            return CountriesService.getPage(vm.countriesFilter)
                .then(function (response) {
                    vm.bankCountries = response.result;
                })
                .catch(function () {

                });
        };

        vm.getDebitAccountList = function () {
            return PaymentTypesService.getByGroup({
                paymentTypeGroup: 'ForeignPayment'
            })
                .then(function (response) {
                    if (_.isArray(response.result) && response.result.length > 0) {
                        vm.accountsFrom = response.result[0].debitAccountList;
                        _.forEach(vm.accountsFrom, function (item) {
                            if (item.accountDescription) {
                                item.optionValue = item.accountDescription + ' - ' + item.iban;
                            }
                        });
                    }
                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        vm.purposeCodeChange = function (purposeCode) {
            vm.tempForpObj.purposeCodeSelect = purposeCode;
            // vm.tempForpObj.paymentPurposeInput = purposeCode.description;
            var purpose = _.find(vm.purposeCodes, {
                purposeDesc: vm.tempForpObj.paymentPurposeInput
            });
            if (purpose) {
                vm.tempForpObj.paymentPurposeInput = purposeCode.purposeDesc;
            }

            // var purposeCode = _.findIndex(vm.purposeCodes, function (item) {
            //   vm.tempForpObj.paymentPurposeInput = item.description;
            //   return item.id == code.id;
            // });
        };

        vm.openDatePicker = function () {
            vm.datePickerOpened = true;
        };

        vm.getBankInfo = function () {
            BicBanksService.getByIban(vm.tempForpObj.recipientAccountInput)
                .then(function (response) {
                    if (_.isArray(response.result) && response.result.length > 0) {
                        vm.tempForpObj.bankNameInput = response.result[0].institutionName;
                        vm.tempForpObj.bankCityInput = response.result[0].city;
                        vm.tempForpObj.swiftCodeInput = response.result[0].swiftCode;
                    }
                })
                .catch(function (error) {
                    NotificationService.showMessage(error, 'error');
                });
        };

        /////////////////////////////CUSTOM SELECT////////////////////////////

        vm.toggleFilterSelection = function () {
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
        };

        vm.searchPayee = function () {
            vm.searchFilterExpanded = true;
        };

        vm.getPayees = function () {
            PaymentTemplatesService.getPage(vm.payeeFilter)
                .then(function (response) {
                    vm.payeeList = response.result;
                    if ($state.params && $state.params.templateId) {
                        vm.selectTemplate($state.params.templateId);
                    }
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.selectPayee = function (id) {
            var item = _.find(vm.payeeList, {
                id: id
            });
            vm.tempForpObj.receiversAddressInput = item.receiverAddress1;
            vm.tempForpObj.receiversNameInput = item.receiverName;
            vm.tempForpObj.receiversPostalCodeAndCityInput = item.receiverCity;
           
            // Bind to BIC
            if (!vm.bicPopulated) {
                vm.tempForpObj.toAccountInput = item.toAccountNumber;
                vm.getBicByIban();
            }

            vm.searchFilterExpanded = !vm.searchFilterExpanded;
        };

        vm.removeSearch = function () {
            vm.tempForpObj.receiversNameInput = '';
            vm.tempForpObj.receiversAddressInput = '';
            vm.tempForpObj.receiversPostalCodeAndCityInput = '';
        };

        vm.searchPayeeBy = function (searchrow) {
            return (angular.$$lowercase(searchrow.receiverName).indexOf(angular.$$lowercase(vm.tempForpObj.receiversNameInput) || '') !== -1 ||
                angular.$$lowercase(searchrow.toAccountNumber).indexOf(angular.$$lowercase(vm.tempForpObj.receiversNameInput) || '') !== -1);
        };


        ////////////////select template component//////////////////////
        vm.searchTemplate = function () {
            vm.searchTemplateFilterExpanded = true;
            if (vm.searchTemplateFilterExpanded === true) {
                $timeout(function () {
                    var searchTemplatesInput = angular.element('#searchTemplatesInput');
                    searchTemplatesInput.focus();
                }, 500);
            }
        };

        vm.toggleTemplateFilterSelection = function () {
            vm.getPaymentTemplatesPage();
            vm.searchTemplateFilterExpanded = !vm.searchTemplateFilterExpanded;
        };

        vm.getPaymentTemplatesPage = function () {
            PaymentTemplatesService.getPage(vm.templatesFilter)
                .then(function (response) {
                    vm.templateList = response;
                    $log.debug(vm.templateList);
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.documentation = function (paymentObj) {
            var stateLink = 'payments.internationalPayment.documentationPayment';
            var params = {
                paymentId: paymentObj.id
            };
            if (stateLink) {
                $state.go(stateLink, params);
            }
        };

        vm.selectTemplate = function (id) {
            GoogleTagManagerHelperService.pushEvent('InternationalPayment', 'PaymentTemplateSelection', 'Template with id ' + id + ' selected');
            var item = _.find(vm.payeeList, {
                id: +id
            });
            loadAccountData(item.accountId);
            vm.tempForpObj.toAccountInput = item.toAccountNumber;
            vm.tempForpObj.receiversAddressInput = item.receiverAddress1;
            vm.tempForpObj.receiversNameInput = item.receiverName;
            vm.tempForpObj.receiversPostalCodeAndCityInput = item.receiverCity;
            vm.tempForpObj.paymentPurposeInput = item.purpose;
            vm.tempForpObj.paymentPurposeReceiverInfoInput = item.memo || '';

            if (item.paymentReasonCode && vm.purposeCodes.length > 0) {
                var index = _.findIndex(vm.purposeCodes, function (value) {
                    return value.id === item.paymentReasonCode;
                });
            if (index && index != -1) {
                    vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[index];
                } else {
                    vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[0];
                }
            }

            // Populate BIC fields from template
            vm.tempForpObj.swiftCodeInput = item.beneficiarySWIFTCode;
            vm.bicCodeSearchFilter = item.beneficiarySWIFTCode;
            vm.tempForpObj.bankAddressInput = item.beneficiaryBankAddress;
            vm.tempForpObj.bankCityInput = item.beneficiaryBankCity;
            vm.tempForpObj.bankNameInput = item.beneficiaryBankName;
            vm.tempForpObj.bankChargesRadiobutton.type = item.paymentCharges || '';

            var country = _.find(vm.countriesOptions, {
                code: item.beneficiaryBankCountryCode
            });
            if (country) {
                vm.onCountrySelect(country);
                vm.onBankCountrySelect(country);
            }
            vm.templateName = item.name;
            //vm.payeeSearchFilter = item.receiverName;
            vm.tempForpObj.receiversNameInput = item.receiverName;
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
            vm.searchFilterExpanded = false;
            vm.searchTemplateFilterExpanded = false;
            vm.getBicByIban(true, true);
            vm.steps.step1 = true;
            vm.steps.step2 = false;
        };

        vm.calculateTotalAmountWithFee = function () {
            if (!vm.tempForpObj.amountInput || !vm.tempForpObj.bankChargesRadiobutton.type) {
                vm.totalAmountWithFee = '';
                return;
            }
            PaymentsService.getTotalAmountWithFee({ amount: vm.tempForpObj.amountInput, 
                                                    currencySymbol: vm.tempForpObj.fromAccountSelect.currencySymbol, 
                                                    paymentCharges: +vm.tempForpObj.bankChargesRadiobutton.type })
                .then(function (response) {
                    vm.totalAmountWithFee = response;
                });
        }

        vm.removeTemplate = function () {
            vm.searchTemplateFilterExpanded = false;
            vm.templateName = '';
            //vm.payeeSearchFilter = '';
            vm.tempForpObj.receiversNameInput = '';
            vm.countrySearchFilter = '';
            vm.bicCodeSearchFilter = '';
            vm.tempForpObj.swiftCodeInput = "";
            vm.tempForpObj.bankAddressInput = "";
            vm.tempForpObj.bankCityInput = "";
            vm.tempForpObj.bankNameInput = "";
            vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[0];
            vm.tempForpObj.paymentPurposeInput = vm.purposeCodes[0].purposeDesc;
            vm.tempForpObj.paymentPurposeReceiverInfoInput = '';
            //vm.tempForpObj.modalityCode = vm.paymentModeOptions[0];

            // vm.tempForpObj = {};
            vm.tempForpObj.toAccountInput = '';
            vm.tempForpObj.receiversAddressInput = '';
            vm.tempForpObj.receiversPostalCodeAndCityInput = '';
            vm.tempForpObj.amountInput = '';
            vm.steps.step1 = true;
            vm.steps.step2 = false;
        };

        var fillReceiversInput = function (response) {
            if (response.result.length > 0) {
                vm.tempForpObj.receiversNameInput = response.result[0].receiverName;
                //vm.payeeSearchFilter = response.result[0].receiverName;
                vm.tempForpObj.receiversAddressInput = response.result[0].receiverAddress1;
                vm.tempForpObj.receiversPostalCodeAndCityInput = response.result[0].receiverCity;
                // TODO: Populate bic number (currently request returns nothing)
            }
        };

        vm.fillReceiver = function (toAccountInput) {
            if (!toAccountInput) return;
            toAccountInput = toAccountInput;
            if (toAccountInput.substring(0, 2) === 'HR') {
                CreditAccountRegisterService.getByIban(toAccountInput)
                    .then(function (response) {
                        fillReceiversInput(response);
                    })
                    .catch(function (error) {
                        NotificationService.showMessage(error, 'error');
                    });
            } else {
                CreditAccountRegisterService.getPage({
                    accountNumber: toAccountInput
                })
                    .then(function (response) {
                        fillReceiversInput(response);
                    })
                    .catch(function (error) {
                        NotificationService.showMessage(error, 'error');
                    });
            }
        };

        /*      vm.signPayment = function () {
         PaymentsService.openSignModal(vm.paymentResponse.id)
         .then(function (signed) {
         if (signed) {
         vm.steps = {
         step1: false,
         step2: false,
         step3: true
         };
         }
         })
         .catch(function (error) {
         NotificationService.showMessage(error, 'error');
         });
         };*/

        var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        $rootScope.$on('appLanguageChangedHeader', function () {
            sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        });

        vm.deletePayment = function () {
            //swal({
            //  title: sweetAlertOptions.areYouSure,
            //  type: "info",
            //  showCancelButton: true,
            //  confirmButtonClass: "btn-default",
            //  confirmButtonText: sweetAlertOptions.yes,
            //  cancelButtonText: sweetAlertOptions.no,
            //  closeOnConfirm: true,
            //  closeOnCancel: true
            //}, function (isConfirm) {
            //  if (isConfirm) {
            //    PaymentsService.deletePayment(vm.paymentResponse.id)
            //      .then(function (response) {
            //      HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], vm.paymentResponse.id);
            //      $state.go('payments.paymentsOverview');
            //    })
            //      .catch(function (error) {
            //      NotificationService.showMessage(error, 'error');
            //    });
            //  }
            //});

            AlertService.confirmationAlert()
                .then(function (result) {
                    if (result) {
                        PaymentsService.deletePayment(vm.paymentResponse.id)
                            .then(function (response) {
                                AlertService.deletedPaymentAlert({
                                    paymentName: vm.paymentResponse.id,
                                    type: 'payment'
                                })
                                    .then(function () {
                                        $state.go('payments.paymentsOverview');
                                    });
                            })
                            .catch(function (error) {
                                NotificationService.showMessage(error, 'error');
                            });
                    }
                })
                .catch(function () {
                    $log.debug('Example failed!');
                });
        };

        vm.editPayment = function () {
            vm.forUpdate = true;
            vm.steps = {
                step1: true,
                step2: false,
                step3: false
            };
        };

        vm.clearSepaReceiver = function (e) {
            vm.tempForpObj.receiversSepaInput1 = '';
            vm.tempForpObj.receiversSepaInput2 = '';
        };

        vm.clearSepaPayer = function () {
            vm.tempForpObj.payersSepaInput1 = '';
            vm.tempForpObj.payersSepaInput2 = '';
        };


        var loadAccountData = function (accountId) {
             var fromAccount = _.find(vm.accountsFrom, function (item) {
                return item.accountId == accountId;
            });
            vm.tempForpObj.fromAccountSelect = fromAccount;
        };

        //var loadPaymentDataFromTemplate = function (templateId) {
        //  if (templateId) {
        //    PaymentTemplatesService.getById(templateId)
        //      .then(function (response) {
        //      vm.tempForpObj.amountInput = $filter('number')(response.amount, 2);
        //      vm.tempForpObj.recipientAccountInput = response.toAccountNumber;
        //      vm.tempForpObj.paymentPurposeInput = response.purpose;
        //      vm.tempForpObj.fullNameCompanyInput = response.payeeName || '';
        //      vm.tempForpObj.recipientAddressInput = response.payeeAddress1 || '';
        //      vm.tempForpObj.recipientCityInput = response.payeeCity || '';
        //      loadAccountData(response.accountId);
        //    })
        //      .catch(function (error) {
        //      NotificationService.showMessage(error, 'error');
        //    });
        //  }
        //};

        var loadPaymentData = function (paymentId) {
            vm.steps.step1 = false;
            vm.steps.step2 = true;
            if (paymentId) {
                PaymentsService.getById(paymentId)
                    .then(function (response) {

                        var country = _.find(vm.countriesOptions, {
                            code: response.beneficiaryBankCountryCode
                        });
                        if (country) {
                            vm.onCountrySelect(country);
                            vm.onBankCountrySelect(country);
                            // vm.countrySearchFilter = country.description;
                            // vm.tempForpObj.bankCountrySelect = country;
                        }

                        vm.tempForpObj.amountInput = response.amount;
                        //vm.tempForpObj.toAccountInput = response.toAccountNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
                        vm.tempForpObj.toAccountInput = response.toAccountNumber;
                        vm.tempForpObj.recipientAccountInput = response.toAccountNumber;
                        //vm.payeeSearchFilter = response.receiverName;
                        vm.tempForpObj.receiversNameInput = response.receiverName;
                        vm.tempForpObj.receiversAddressInput = response.receiverAddress1;
                        vm.tempForpObj.paymentPurposeInput = response.purpose;
                        vm.tempForpObj.paymentPurposeReceiverInfoInput = response.memo || '';
                        vm.tempForpObj.fullNameCompanyInput = response.payeeName || '';
                        vm.tempForpObj.recipientAddressInput = response.payeeAddress1 || '';
                        vm.tempForpObj.recipientCityInput = response.payeeCity || '';
                        vm.tempForpObj.bankAddressInput = response.beneficiaryBankAddress;
                        vm.tempForpObj.bankCityInput = response.beneficiaryBankCity;
                        vm.tempForpObj.bankNameInput = response.beneficiaryBankName;
                        vm.tempForpObj.email = response.email;
                        vm.tempForpObj.phone = response.phone;
                        //vm.tempForpObj.modalityCode = response.modalityCode;
                        vm.tempForpObj.bankChargesRadiobutton.type = response.paymentCharges || '';
                        vm.tempForpObj.recipientStatusRadiobutton.type = response.payeeLegalForm || '2';
                        vm.tempForpObj.swiftCodeInput = response.beneficiarySWIFTCode;
                        vm.tempForpObj.receiversPostalCodeAndCityInput = response.receiverCity;
                        vm.bicCodeSearchFilter = response.beneficiarySWIFTCode;
                        loadAccountData(response.accountId);

                        var index = _.findIndex(vm.purposeCodes, function (item) {
                            return response.paymentReasonCode === item.purposeCode;
                        })
                        if (index) {
                            vm.tempForpObj.purposeCodeSelect =  vm.purposeCodes[index];
                        } else {
                           //  vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[0];
                        }

                        vm.calculateTotalAmountWithFee();
                        
                        vm.paymentResponse.id = paymentId;
                        if ($state.params.editable)
                            vm.forUpdate = true;

                        vm.getBicByIban(true, true);
                    })
                    .catch(function (error) {
                        NotificationService.showMessage(error, 'error');
                    });
            }
        };

        // --
        // INITIALIZE
        // --
        var populateFieldsWithData = function () {

        };

        vm.downloadInoPaymentGuide = function() {
            var nonBlockingWindow = window.open('', '_blank');
            sessionStorage.setItem('downloadInProgress', 'download');
            nonBlockingWindow.location.href = vm.guideURL;
        };
        vm.init = function () {
            vm.getPaymentTemplatesPage();
            vm.getUserSettingsPage();
            var promises = [
                PaymentsService.getPaymentModes(),
                CountriesService.getPage({
                    pageSize: 1000
                }),
                vm.loadPurposeCode(),
                vm.loadCountries(),
                vm.getDebitAccountList()
            ];

            $q.all(promises)
                .then(function (responses) {
                    vm.getPayees();
                    // Payment Modes Options
                    vm.paymentModeOptions = responses[0].result;
                    // Countries
                    vm.countriesOptions = responses[1].result;

                    //        if ($state.params && $state.params.templateId) {
                    //          loadPaymentDataFromTemplate($state.params.templateId);
                    //        } else
                    if ($state.params && $state.params.paymentId) {
                        loadPaymentData($state.params.paymentId);
                    } else {
                        if (vm.bankCountries.length > 0) {
                            vm.tempForpObj.recipientCountrySelect = vm.bankCountries[0];
                            // vm.tempForpObj.bankCountrySelect = vm.bankCountries[0];
                            // vm.tempForpObj.benBankCountrySelect = vm.bankCountries[0];
                        }
                        if (_.isArray(vm.accountsFrom) && vm.accountsFrom.length > 0) {
                            vm.tempForpObj.fromAccountSelect = vm.accountsFrom[0];
                        }
                    }

                    // if (vm.purposeCodes.length > 0) {
                    //     vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[0];
                    //     vm.tempForpObj.paymentPurposeInput = vm.purposeCodes[0].purposeDesc;
                    // }
                    if (vm.bankCountries.length > 0) {
                        vm.tempForpObj.recipientCountrySelect = vm.bankCountries[0];
                        // vm.tempForpObj.bankCountrySelect = vm.bankCountries[0];
                        // vm.tempForpObj.benBankCountrySelect = vm.bankCountries[0];
                    }

                    vm.guideURL = $rootScope.APP_GLOBAL_SETTINGS.defaultData.InoPaymentGuide;
                    vm.dataLoaded = true;
                })
                .catch(function (error) {
                    NotificationService.showMessage(error, 'error');
                });
        }

        // region Private methods

        /*
         * Create object for POST
         * */
        function createPaymentObject() {
            var paymentObject = {};
            paymentObject.accountId = vm.tempForpObj.fromAccountSelect.accountId;
            paymentObject.fromAccountNumber = vm.tempForpObj.fromAccountSelect.iban;

            //paymentObject.toAccountNumber = (vm.tempForpObj.toAccountInput) ? vm.tempForpObj.toAccountInput.replace(/\s/g, '') : "";
            paymentObject.toAccountNumber = (vm.tempForpObj.toAccountInput) ? vm.tempForpObj.toAccountInput : "";
            paymentObject.currencySymbol = vm.tempForpObj.fromAccountSelect.currencySymbol;
            paymentObject.purpose = vm.tempForpObj.paymentPurposeInput;
            paymentObject.dueDate = vm.tempForpObj.dueDateInput;
            paymentObject.amount = vm.tempForpObj.amountInput;
            paymentObject.paymentTypeGroup = 'ForeignPayment';
            paymentObject.foreignPayment = {
                email: vm.tempForpObj.email,
                phone: vm.tempForpObj.phone,
                paymentReasonCode: vm.tempForpObj.purposeCodeSelect.purposeCode,
                paymentReasonCodeDescription: vm.tempForpObj.paymentPurposeInput,
                memo: vm.tempForpObj.paymentPurposeReceiverInfoInput,
                receiverName: vm.tempForpObj.receiversNameInput,
                receiverAddress1: vm.tempForpObj.receiversAddressInput,
                receiverCity: vm.tempForpObj.receiversPostalCodeAndCityInput,
                senderName: vm.tempForpObj.fromAccountSelect.ownerName,
                senderAddress1: vm.tempForpObj.fromAccountSelect.ownerAddress,
                senderCity: vm.tempForpObj.fromAccountSelect.ownerCity,
                beneficiarySWIFTCode: vm.tempForpObj.swiftCodeInput,
                beneficiaryBankName: vm.tempForpObj.bankNameInput,
                beneficiaryBankAddress: vm.tempForpObj.bankAddressInput,
                beneficiaryBankCity: vm.tempForpObj.bankCityInput,
                beneficiaryBankCountryCode: vm.tempForpObj.bankCountrySelect.code,
                // beneficiaryBankCountry: vm.tempForpObj.bankCountrySelect.description,
                //beneficiaryBankCountry: vm.tempForpObj.benBankCountrySelect.code,
                foreignBankAddress3: "",
                //TODO: Seems like recieverCountryCode selects first country from the list of countries and there is no way to choose one - but is required by backend!!!!!
                receiverCountryCode: vm.tempForpObj.bankCountrySelect.code,
                hasAvailableBalance: false,
                //referenceFrom: null,
                referenceTo: null,
                loanRegistrationNumber: vm.tempForpObj.loanRegistrationNumber,
                loanRegistrationYear: vm.tempForpObj.loanRegistrationYear,
                // need to add field on payment form
             
                //payeeLegalForm: vm.tempForpObj.recipientStatusRadiobutton.type,
                paymentCharges: vm.tempForpObj.bankChargesRadiobutton.type,
                // paymentUsedMode: vm.tempForpObj.paymentUsedMode
                //modalityCode: vm.tempForpObj.modalityCode
                amountWithFee: vm.totalAmountWithFee
            };
            paymentObject.sepaUpnIdentificators = {
                debtorName: vm.tempForpObj.payersSepaInput1,
                debtorName2: vm.tempForpObj.payersSepaInput2,
                creditorName: vm.tempForpObj.receiversSepaInput1,
                creditorName2: vm.tempForpObj.receiversSepaInput2
            };
            return paymentObject;
        }

        // endregion

        // region Public methods

        /*
         * Autocompletes Bank/BIC data when BIC Number is selected
         * */
        vm.onBicBankSelected = function (bbank) {
            // bicBanks API for Slovenia - returns {bicCode: "BSLJSI2X", id: "21"} - not good
            var bicBank = _.find(vm.bicBankOptions, {
                swiftCode: bbank.swiftCode
            });
            vm.tempForpObj.swiftCodeInput = bicBank.swiftCode;
            vm.tempForpObj.bankAddressInput = bicBank.branchInformation;
            vm.tempForpObj.bankCityInput = bicBank.city;
            vm.tempForpObj.bankNameInput = bicBank.institutionName;

            vm.bicCodeSearchFilter = bicBank.swiftCode;
            vm.bicCodeSearchFilterExpanded = false;

            var country = _.find(vm.countriesOptions, {
                countryCodeShort: bicBank.swiftCode.substring(4, 6)
            });
            if (country) {
                vm.onBankCountrySelect(country);
            }

        };

        vm.addSpaceForIban = function (toAccountInput) {
            if (!vm.tempForpObj.toAccountInput) return;
            vm.tempForpObj.toAccountInput = toAccountInput;
        };

        vm.getBicByIban = function (skipBeneficiaryAssignment, fromTemplate) {
            var iban = vm.tempForpObj.toAccountInput;
            iban = iban.replace(/\s/g, '');
           
            return AccountsService.validateIban(iban).then(function(r) {
                vm.ibanInvalid = false;
                vm.bicPopulated = true;
                // Populate SEPA
                vm.isRecipientInSEPA = r.isSepaCreditPayment;
                if (!fromTemplate && !skipBeneficiaryAssignment) {
                    vm.checkIfSEPAPossible();
                }
                if (skipBeneficiaryAssignment) {
                    // In some cases skip country assignment, but do assign bic bank just overriding empty values
                    if (fromTemplate) {
                        vm.disableBicData = true;
                        setBicBankData(r, null, true);
                    }
                    return;
                }

                // Populate receiver country data
                var country = _.find(vm.countriesOptions, {
                    countryCodeShort: r.countryIso || iban.substring(0, 2).toUpperCase()
                });
                if (country) {
                    vm.onCountrySelect(country);
                } else {
                    vm.removeSelectedCountry();
                    vm.countrySearchFilterExpanded = false;
                }

                // Assign bic bank just overriding all values
                vm.disableBicData = true;
                // Populate BIC Bank data
                setBicBankData(r, country);
                
            }).catch(function(err) {
                console.log(err)
                vm.loadingInProgress = false;
                vm.disableBicData = false;
                vm.ibanInvalid = true;
            });
        };

        function setBicBankData(ibanValidationResult, country, keepData) {
            var bic = '';
            var bankName = '';
            var bankAddress = '';
            var bankCity = '';
            if (keepData) {
                bic = vm.tempForpObj.swiftCodeInput || ibanValidationResult.bic;
                bankName = vm.tempForpObj.bankNameInput || ibanValidationResult.bank;
                bankAddress = vm.tempForpObj.bankAddressInput || ibanValidationResult.address;
                bankCity = vm.tempForpObj.bankCityInput || ibanValidationResult.city;
            } else {
                bic = ibanValidationResult.bic || '';
                bankName = ibanValidationResult.bank || '';
                bankAddress = ibanValidationResult.address || '';
                bankCity = ibanValidationResult.city || '';
            }
            vm.tempForpObj.swiftCodeInput = bic;
            vm.bicCodeSearchFilter = bic;
            vm.tempForpObj.bankNameInput = bankName;
            vm.tempForpObj.bankAddressInput = bankAddress;
            vm.tempForpObj.bankCityInput = bankCity;
            if (!country) {
                var iban = vm.tempForpObj.toAccountInput; 
                country = _.find(vm.countriesOptions, {
                    countryCodeShort: ibanValidationResult.countryIso || iban.substring(0, 2).toUpperCase()
                });
            }

            if (!country) {
                return;
            }
            vm.onBankCountrySelect(country);
        }

        vm.searchBICNumber = function (bicInput) {
            vm.bicCodeSearchFilterExpanded = true;
            vm.tempForpObj.swiftCodeInput = bicInput;
            searchBicNumber(bicInput);
            if (bicInput.length >= 6) {
                var country = _.find(vm.countriesOptions, {
                    countryCodeShort: bicInput.substring(4, 6).toUpperCase()
                });
                if (country) {
                    vm.onBankCountrySelect(country);
                    return;
                }
            }
            vm.removeBankSelectedCountry();
            vm.countrySearchFilterExpanded = false;
        };

        function searchBicNumber(bicInput) {
            PaymentsService.getBicBanks(undefined, {
                bicCode: bicInput
            })
                .then(function (response) {
                    vm.bicBankOptions = response.result;
                }, function (error) {

                })
        }

        vm.newPayment = function () {
            $state.go('payments.internationalPayment', {}, {
                reload: true
            })
        };

        vm.removeBicCodeSearch = function () {
            vm.bicCodeSearchFilter = "";
            vm.countryBankSearchFilter = '';
            vm.tempForpObj.swiftCodeInput = "";
            vm.tempForpObj.bankAddressInput = "";
            vm.tempForpObj.bankCityInput = "";
            vm.tempForpObj.bankNameInput = "";
            vm.tempForpObj.benBankCountrySelect = '';
        };

        /*
         * Countries selectbox - on list click
         * */
        vm.onCountrySelect = function (country) {
            vm.countrySearchFilter = country.code + " " + country.description;
            vm.tempForpObj.bankCountrySelect = country;
            vm.countrySearchFilterExpanded = false;
        };

        vm.onBankCountrySelect = function (country) {
            vm.countryBankSearchFilter = country.code + " " + country.description;
            vm.tempForpObj.benBankCountrySelect = country;
            vm.countryBankSearchFilterExpanded = false;
        };

        /*
         * Countries selectbox - remove
         * */
        vm.removeSelectedCountry = function () {
            vm.countrySearchFilter = "";
            vm.tempForpObj.bankCountrySelect = {};
            vm.countrySearchFilterExpanded = true;
        };

        vm.removeBankSelectedCountry = function () {
            vm.countryBankSearchFilter = "";
            vm.tempForpObj.benBankCountrySelect = {};
            vm.countrySearchFilterExpanded = true;
        };

        vm.toggleAccountsFrom = function() {
            if (!vm.steps.step1) {
                return;
            }
            vm.showAccountToDropdown = !vm.showAccountToDropdown
        }

        vm.back = function() {
            vm.steps.step2 = false;
            vm.steps.step1 = true;
        }

        vm.next = function() {
            var iban = vm.tempForpObj.toAccountInput; 

            if (!iban) {
                setBicBankData({});
                vm.bicPopulated = false;
                vm.disableBicData = false;
                return false;
            }

            if (!HelperService.isIbanFormat(iban)) {
                setBicBankData({});
                vm.bicPopulated = false;
                vm.isRecipientInSEPA = false;
                vm.checkIfSEPAPossible();
                vm.disableBicData = false;
                vm.steps.step1 = false;
                vm.steps.step2 = true;
                return;
            }
            
            vm.getBicByIban().then(function() {
                if (!vm.ibanInvalid) {
                    vm.steps.step1 = false;
                    vm.steps.step2 = true;
                }
            });
        }

        /*
         * Called when Review and submit button is clicked
         * */
        vm.submitInternationalPayment = function (event) {
            // Check if form is valid
            vm.tempForpObj.formSubmitted = true;

            if (!vm.paymentForm.$valid) {
                vm.paymentForm.$$controls.forEach(function(control) {
                    if (!control.$valid) {
                        control.$$element.focus();
                    }
                });
                return false;
            }


            // If form is valid create object for update
            var paymentObject = createPaymentObject();

            // If selected country has amlControl call statement confirmation modal
            if (vm.tempForpObj.bankCountrySelect.amlControl) {
                // PaymentsService.openStatementConfirmModal(vm.tempForpObj.bankCountrySelect)
                PaymentsService.openStatementConfirmModal(vm.tempForpObj)
                    .result.then(function (result) {
                        // Add more information to payment object
                        if (!result)
                            return;
                        else {
                            paymentObject.foreignPayment.beneficiaryBankCountryCode = result.stateOption;
                            paymentObject.foreignPayment.foreignBankAddress3 = result.information;
                        }
                        upsertInternationalPayment(paymentObject);

                    });
                return;
            }

            upsertInternationalPayment(paymentObject);
        };

        function upsertInternationalPayment(paymentObject) {
            if (!vm.formSubmitted) {
                vm.formSubmitted = true;
                if (vm.forUpdate) {
                    paymentObject.id = vm.paymentResponse.id;
                    PaymentsService.updatePayment(vm.paymentResponse.id, paymentObject)
                        .then(function (response) {
                            postPaymentAction(response);
                            vm.forUpdate = false;
                        })
                        .catch(function (error) {
                            NotificationService.showMessage(error, 'error');
                            // vm.forUpdate = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                } else {
                    PaymentsService.insertPayment(paymentObject)
                        .then(function (response) {
                            postPaymentAction(response);
                            GoogleTagManagerHelperService.pushVirtualPageView('payments/international-payment/toconfirm', 'payments international-payment toconfirm', $location.host() + $location.host() + 'payments/international-payment/toconfirm');
                        })
                        .catch(function (error) {
                            NotificationService.showMessage(error, 'error');
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                }
            }
        }

        function postPaymentAction(response) {
            if (!response.hasAvailableBalance) {
                AlertService.infoAlert({
                    text: "internationalPayment.hasAvailableBalanceWarning", btnKey: 'OK' }).then();
            }
            vm.paymentResponse = response;
            vm.paymentResponse.dueDate = new Date(response.dueDate);
            vm.paymentResponse.paymentTypeGroup = 'ForeignPayment';
            vm.paymentResponse.purposeCodeValue = vm.tempForpObj.purposeCodeSelect.optionValue;
            switch (response.paymentCharges) {
                case "1":
                    vm.paymentResponse.bankCharges = "Payers pays charges";
                    break;
                case "2":
                    vm.paymentResponse.bankCharges = "Beneficiary pays charges";
                    break;
                case "3":
                    vm.paymentResponse.bankCharges = "Shared charges";
                    break;
            }

            // Remap payment mode
            var modality = _.find(vm.paymentModeOptions, {
                id: vm.paymentResponse.modalityCode
            });
            if (modality) {
                vm.paymentResponse.modalityCode = modality.id + " " + modality.description;
            }

            var country = _.find(vm.countriesOptions, {
                code: vm.paymentResponse.beneficiaryBankCountryCode
            });
            if (country) {
                vm.paymentResponse.beneficiaryBankCountryCode = country.code + " " + country.description;
            }

            vm.paymentResponse.payeeListId = vm.tempForpObj.recipientStatusRadiobutton.type;
            vm.steps = {
                step1: false,
                step2: false,
                step3: true,
                step4: false,
            };
        }

        vm.checkIfSEPAPossible = function() {
                if (vm.isRecipientInSEPA && vm.tempForpObj.fromAccountSelect.currencySymbol === 'EUR') {
                        // By default, select SEPA if possible
                    vm.tempForpObj.bankChargesRadiobutton.type = '4';
                } else {
                        // Otherwise, SHA is default
                    vm.tempForpObj.bankChargesRadiobutton.type = '3';
                }
            
        }
        // endregion
        vm.init();
    }
}());
